import { useFormikContext } from 'formik';
import { FC, useMemo } from 'react';

import ActiveFilters from '@components/ProductsList/ActiveFilters';

import { FormValues } from '../../../../types';
import { clearFilterValue, createRemoveFilterHandler, getFieldName, normalizeFieldName } from '../../../../utils';
import { containerStyles } from './styles';
import { ActiveFiltersSectionProps } from './types';

const ActiveFiltersSection: FC<ActiveFiltersSectionProps> = ({
    filterData,
    fieldPrefix,
    currentPriceRange,
    currentRangeDefault,
    rememberedPrice,
    setRememberedPrice,
    onFilterChange,
    hideClearButton,
    containerCss,
}) => {
    const { values, setFieldValue } = useFormikContext<FormValues>();

    const formValuesForActiveFilters = useMemo(() => {
        const result: FormValues = {};
        const isPreOrderFieldName = getFieldName('popup_isPreOrder', fieldPrefix);

        Object.keys(values).forEach(key => {
            const fieldName = normalizeFieldName(key, fieldPrefix);
            const value = values[key];

            if (value === undefined || value === null) return;

            if (key === isPreOrderFieldName && typeof value === 'boolean') {
                if (value) {
                    result['isPreOrder'] = value;
                }

                return;
            }

            if (fieldName === 'price' && value) {
                if (rememberedPrice) {
                    result[fieldName] = rememberedPrice;
                }

                return;
            }

            if (Array.isArray(value) && value.length > 0) {
                result[fieldName] = value;
            }
        });

        return result;
    }, [values, fieldPrefix, rememberedPrice]);

    if (Object.keys(formValuesForActiveFilters).length === 0) {
        return null;
    }

    return (
        <div css={[containerStyles, containerCss]}>
            <ActiveFilters
                filterFields={filterData}
                sortFilter={{
                    sort: 'id',
                    isSale: Boolean(values[getFieldName('isSale', fieldPrefix)]),
                    isPreOrder: !!values[getFieldName('popup_isPreOrder', fieldPrefix)],
                }}
                hideClearButton={hideClearButton}
                priceRange={currentPriceRange}
                filters={formValuesForActiveFilters}
                onRemoveFilter={(filter: { key: string; value: string | number }) => {
                    createRemoveFilterHandler({
                        filter,
                        fieldPrefix,
                        values,
                        currentRangeDefault,
                        setRememberedPrice,
                        setFieldValue,
                        onFilterChange,
                    });
                }}
                onClearAll={() => {
                    Object.keys(values).forEach(key => {
                        const fieldName = normalizeFieldName(key, fieldPrefix);
                        clearFilterValue({
                            key,
                            fieldName,
                            value: values[key],
                            currentRangeDefault,
                            setRememberedPrice,
                            setFieldValue,
                            updatedValues: {},
                            fieldPrefix,
                        });
                    });
                }}
            />
        </div>
    );
};

export default ActiveFiltersSection;
